import {Component} from '@angular/core';
import {UserService} from '../../../../services/user.service';
import {AuthService} from '../../../../services/auth.service';
import environment from '../../../../../environment';

@Component({
  selector: 'delete-account-confirm',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class DeleteAccountConfirmComponent {
  constructor(public userService: UserService, public auth: AuthService) {}

  async deleteAccountConfirm() {
    try {
      const result = await this.userService.deleteUserAccount();
      if (result) {
        this.auth.logout();
        localStorage.clear();
      }
    } catch (error) {
      if (environment.settings.verboseLogging) {
        console.error('Error deleting account:', error);
      }
    }
  }
}
